import Vue from 'vue';
import Vuex from 'vuex';
import meta from '@/api/Meta';
import createCase from '@/api/CreateCase';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        goBack: false,
    },
    mutations: {

        goBack(state, goBack) {
            state.goBack = goBack;
        },
    },
    actions: {
        checkAvailability({}, payload) { 
            return new Promise((resolve) => {
                meta.checkAvailability(payload).then((response) => {
                    resolve(response);
                }).catch(error => {
                    reject(error)
                })
            });
        },
        goBack({ commit }) {
            if (this.state.goBack == false) {
                commit('goBack', true);
            } else {
                commit('goBack', false);
            }
        },
        submitCase({}, payload) {
            createCase
                .submitCase(payload)
                .then((response) => {
                    console.log(response);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }
});
